//--------------------------------------------------------------------//
//******************** AgentLogsService ********************************//
//--------------------------------------------------------------------//
// API communication layer for an agent's run logs (one file per turn,
// terminal session, or scheduled task).
import { request } from '../agents.request.js';

angular.module('agentsTableModule')

    .service('AgentLogsService', [function () {
        // Lists the agent's run logs (name + last-modified date), newest first.
        this.getLogs = function (agentId) {
            return request(`/agents/${encodeURIComponent(agentId)}/logs`, {}, 'GET');
        };

        // Fetches the content of a single log file by name.
        this.getLog = function (agentId, name) {
            return request(`/agents/${encodeURIComponent(agentId)}/log?name=${encodeURIComponent(name)}`, {}, 'GET');
        };
    }]);
